module.exports = __webpack_public_path__ + "static/landing-a4c3689ba2e3ec0b70d9fa7dd2d3b6ad.png";